// A004-A005 點擊驗證信重設密碼
<template>
  <CustomRow>
    <v-card
      v-if="!pageLoading"
      class="mt-5 text-center"
      :class="verifyKey ? 'cusPadding' : 'failedCusPadding'"
    >
      <template v-if="verifyKey">
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="10" sm="8" md="6">
            <div class="text-page-title font-weight-bold">{{ $t('reset_pwd_title') }}</div>
            <div class="mt-5" v-html="$t('change_pwd_notification')">
            </div>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="10" sm="6" md="4">
            <v-form v-model="isFormValid">
              <v-text-field
                class="mt-5"
                :label="$t('set_password')"
                outlined
                color="primary-1"
                autofocus
                v-model="password"
                :rules="[
                  inputRules.required,
                  inputRules.passwordLength,
                  inputRules.password
                ]"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                :type="showPassword ? 'text' : 'password'"
              >
                <template #message="{message}">
                  {{ $t(message) }}
                </template>
              </v-text-field>
              <v-text-field
                class="mt-10"
                :label="$t('confirm_password')"
                outlined
                color="primary-1"
                v-model="confirmPassword"
                :rules="[inputRules.required, inputRules.matchPassword]"
                :append-icon="showAgainPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showAgainPassword = !showAgainPassword"
                :type="showAgainPassword ? 'text' : 'password'"
                @input="inputField"
                :error-messages="
                  passwordNotMatch ? $t('password_match_error') : ''
                "
              >
                <template #message="{message}">
                  {{ $t(message) }}
                </template>
              </v-text-field>
              <v-btn
                class="mt-8 font-weight-bold nextBtn"
                :class="{ disabledBtn: !isFormValid || !loadingFinished }"
                :disabled="!isFormValid || !loadingFinished"
                block
                depressed
                x-large
                @click="resetPassword"
              >
                <template v-if="!loadingFinished">
                  <v-progress-circular
                    indeterminate
                    color="white"
                    size="25"
                    width="2"
                  ></v-progress-circular>
                </template>
                <template v-else>
                  {{ $t('reset_pwd_cta') }}
                </template>
              </v-btn>
            </v-form>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </template>
      <template v-else>
        <v-img
          src="@/assets/image/images-mail-fail@3x.png"
          :width="imageWidth"
          class="mx-auto mb-5"
        ></v-img>
        <div class="mt-5 mb-10 text-header-title font-weight-bold">
          {{ $t('reset_pwd_verify_fail_title') }}
        </div>
        <div class="text-title font-weight-bold">
          {{ $t('reset_pwd_verify_fail_content') }}
        </div>
        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="10" sm="6" md="4">
            <v-btn
              outlined
              color="primary"
              block
              x-large
              class="mt-8 font-weight-bold rounded-lg"
              style="border: 3px solid;"
              @click="$router.push({ name: 'ForgotPassword' })"
              >{{ $t('login_forget_password') }}</v-btn
            >
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </template>
    </v-card>
  </CustomRow>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import inputRulesJS from "@/shared/inputRules.js";
import UM from "@/api/user-management";

export default {
  data() {
    return {
      pageLoading: true,
      verifyKey: false,
      isFormValid: false,
      password: "",
      confirmPassword: "",
      showPassword: false,
      showAgainPassword: false,
      inputRules: {
        required: inputRulesJS.required,
        passwordLength: inputRulesJS.passwordLength,
        password: inputRulesJS.password,
        matchPassword: () => {
          return (
            this.confirmPassword === this.password ||
            this.$t('password_match_error')
          );
        }
      },
      loadingFinished: true,
      key: "",
      passwordNotMatch: false
    };
  },
  metaInfo() {
    return {  
      title: `${this.$t('reset_pwd_title')} - ${this.$t('app_name')}`,
      script: [{
        type: 'application/ld+json',
        json: {
          "@context" : "https://schema.org",
          "@type" : "WebSite",
          "name" : `${this.$t('reset_pwd_title')} - ${this.$t('app_name')}`,
          "url" : window.location.href
        }
      }]
    }
  },
  computed: {
    ...mapGetters({
      dialog: "dialog/dialog"
    }),
    imageWidth() {
      if (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm)
        return "100";
      else return "120";
    }
  },
  async mounted() {
    const key = this.$route.query.key;
    if (!key) {
      this.showDialog({
        alert: true,
        content: `<div class="pa-6 text-center font-weight-bold">
            <img
              src="/image/ic-warning@3x.png"
              alt=""
              style="width:80px"
            />
            <div class="mt-5">${this.$t('pwd_link_error')}</div>
          </div>`
      });
      setTimeout(() => {
        this.$router.push({ name: "Index" }).catch(()=>{});
      }, 2000);
    } else {
      this.$store.dispatch("setOverlayLoading", true);
      const { data } = await UM.verifyPassword(key);
      // if (data.errCode !== "00") {
      //   alert(`${data.errCode}\n${data.errMsg}\n${data.errDetail}`);
      // }
      // todo handle error
      switch (data.errCode) {
        case "00":
          this.verifyKey = true;
          this.key = key;
          break;
        case "101":
          break;
        case "102":
          break;
        case "104":
          break;
        default:
          break;
      }
      this.$store.dispatch("setOverlayLoading", false);
      this.pageLoading = false;
    }
  },
  methods: {
    ...mapActions({
      showDialog: "dialog/show",
      showLogIn: "login/show",
      logout: "user/logout"
    }),
    async resetPassword() {
      if (this.confirmPassword !== this.password)
        return (this.passwordNotMatch = true);

      this.loadingFinished = false;
      if (this.key && this.password) {
        const { data: resetPasswordRes } = await UM.resetPassword(
          this.key,
          this.password
        );
        if (resetPasswordRes.errCode !== "00")
          console.log(
            `${resetPasswordRes.errCode}\n${resetPasswordRes.errMsg}\n${
              resetPasswordRes.errDetail
            }`
          );
        // todo handle error
        switch (resetPasswordRes.errCode) {
          case "00":
            this.showDialog({
              alert: true,
              content: `<div class="pa-6 text-center font-weight-bold">
            <img
              src="/image/ic-success@3x.png"
              alt=""
              style="width:80px"
            />
            <div class="mt-5">${this.$t('reset_pwd_submit_success')}</div>
          </div>`
            });
            setTimeout(() => {
              this.logout();
              this.$router.push({
                name: 'Index'
              }).catch(()=>{});
              this.showLogIn();
            }, 2000);
            break;
          case "101":
            // 傳入參數有誤
            break;
          case "102":
            // 內部系統錯誤
            break;
          case "104":
            // 找不到 key || 驗證過期
            break;
          default:
            break;
        }
      }
      this.loadingFinished = true;
    },
    inputField() {
      this.passwordNotMatch = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.cusPadding {
  padding: 50px 20px;
}

.failedCusPadding {
  padding: 60px 20px;
}
</style>
